import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/api";

export const getDepartmentList = (companyId?: number) =>
    axiosInstance.get(API_ENDPOINTS.getDepartmentList(companyId));

export const createDepartment = (data: { parentId?: number | null; name: string; description?: string; companyIds: number[] }) =>
    axiosInstance.post(API_ENDPOINTS.createDepartment, data);

export const updateDepartment = (data: { id: number; parentId?: number | null; name: string; description?: string; companyIds: number[] }) =>
    axiosInstance.put(API_ENDPOINTS.updateDepartment, data);

export const deleteDepartment = (id: number) =>
    axiosInstance.delete(API_ENDPOINTS.deleteDepartment(id));
